import React from "react";
import Alert from "react-bootstrap/Alert";
import TasksActionsPanelNew from "../../tasks-actions-panel/tasks-actions-panel-new";
import PropTypes from "prop-types";
import TaskEditedStandard from "../../task-edited-standard/task-edited-standard";

const TaskEditTop = ({
  standardTask,
  panelVisibility,
  setPanelVisibility,
  alertConfig,
  setAlertConfig,
  labels
}) => {
  const renderTasksActionsPanel = () => {
    let type, button, customLabel;
    switch (panelVisibility.showActionsPanel) {
      case 1:
        type = "Decline Task";
        button = "Decline";
        customLabel = `Decline ${labels?.TaskSingular ?? 'Task' }`;
        break;
      case 2:
        type = "Approve Task";
        button = "Approve";
        customLabel = `Approve ${labels?.TaskSingular ?? 'Task' }`;
        break;
      case 3:
        type = "Cancel Task";
        button = "Cancel";
        customLabel = `Cancel ${labels?.TaskSingular ?? 'Task' }`;
        break;
      case 4:
        type = "Request Review";
        button = "Request Review";
        break;
      case 5:
        type = "Complete Task";
        button = "Complete";
        customLabel = `Complete ${labels?.TaskSingular ?? 'Task' }`;
        break;
      default:
        return <></>;
    }

    return (
      <TasksActionsPanelNew
        show={panelVisibility.showActionsPanel}
        onHide={() =>
          setPanelVisibility((prev) => ({ ...prev, showActionsPanel: 0 }))
        }
        type={type}
        task={standardTask}
        button={button}
        editPage={true}
        customLabel={customLabel}
        labels={labels}
      ></TasksActionsPanelNew>
    );
  };

  return (
    <>
      {alertConfig.showAlert && alertConfig.alertVariant !== "warning" && (
        <Alert
          show={alertConfig.showAlert}
          onClose={() =>
            setAlertConfig((prev) => ({
              ...prev,
              showAlert: false,
              alertAction: "",
              alertMessage: "",
              alertVariant: "",
            }))
          }
          variant={alertConfig.alertVariant}
          dismissible
        >
          <Alert.Heading>{alertConfig.alertAction}</Alert.Heading>
          <p>{alertConfig.alertMessage}</p>
          <hr />
        </Alert>
      )}

      {panelVisibility.showCreatedModal && (
        <TaskEditedStandard
          show={panelVisibility.showCreatedModal}
          onHide={(e) => {
            window.location.reload();
          }}
          isSubtask={false}
          onCreateNew={() => {
            window.location.reload();
          }}
          labels={labels}
        />
      )}

      {renderTasksActionsPanel()}
    </>
  );
};

export default TaskEditTop;
TaskEditTop.propTypes = {
  standardTask: PropTypes.object,
  panelVisibility: PropTypes.object,
  setPanelVisibility: PropTypes.func,
  alertConfig: PropTypes.object,
  setAlertConfig: PropTypes.func,
  labels: PropTypes.shape({
      ProjectSingular: PropTypes.string,
      ProjectPlural: PropTypes.string,
      ProjectSingularPossessive: PropTypes.string,
      ProjectPluralPossessive: PropTypes.string,
      TaskSingular: PropTypes.string,
      TaskPlural: PropTypes.string,
      TaskSingularPossessive: PropTypes.string,
      TaskPluralPossessive: PropTypes.string,
      FormSingular: PropTypes.string,
      FormPlural: PropTypes.string,
      FormSingularPossessive: PropTypes.string,
      FormPluralPossessive: PropTypes.string,
  }),
};